import { CurrentDto } from "../../types/current.dto";
import { SET_CURRENT } from "../types/current";

export const setCurrent = (payload: CurrentDto | null) => {
  return { type: SET_CURRENT, payload };
};
